import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureGetMaster, successGetMaster } from "./MasterSlicer";
import { IMasterList } from "../../../Pages/Master/IMaster";
import { PayloadAction } from "@reduxjs/toolkit";
import { failureAddMaster, successAddMaster } from "./AddMasterSlicer";
import { failureUpdateMaster, successUpdateMaster } from "./UpdateMasterSlicer";
import { failureDeleteMaster, successDeleteMaster } from "./DeleteMasterSlice";
import { failureUnlockMaster, successUnlockMaster } from "./UnlockMasterSlice";
import { Phone } from '@mui/icons-material';

const MasterApi = (action: any) => {
  const { page, pageSize, sortField, sortOrder } = action.payload || {};

  const query = new URLSearchParams();

  if (page !== undefined && pageSize !== undefined) {
    query.append("skip", String(page * pageSize)); // ✅ correct
    query.append("limit", String(pageSize));
  }
  if (sortField) query.append("sortField", sortField);
  if (sortOrder) query.append("sortOrder", sortOrder);
  return api.get(`/users/?${query.toString()}`);
};

export function* MasterCall(action: any) {
  try {
    const response: AxiosResponse = yield call(MasterApi, action);
    yield put(successGetMaster(response.data));
  } catch (error) {
    yield put(failureGetMaster(error));
  }
}

// add master
const AddMasterApi = (action: PayloadAction<IMasterList>) => {
  const data = {
    first_name: action.payload.first_name,
    last_name: action.payload.first_name,
    email: action.payload.email,
    Phone: action.payload.phone,
    status: action.payload.status,
  };
  
  return api.post('/users/signUp', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export function* AddMasterCall(action: PayloadAction<IMasterList>) {
  try {
    const response: AxiosResponse = yield call(AddMasterApi, action);
    yield put(successAddMaster(response.data));
  } catch (error) {
    yield put(failureAddMaster(error));
  }
}

// update master
const UpdateMasterApi = (action: PayloadAction<IMasterList>) => {
  const formData = new FormData();

  Object.entries(action.payload).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const url = `/users/${action.payload.id}`;

  return api.patch(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export function* UpdateMasterCall(action: PayloadAction<IMasterList>) {
  try {
    const response: AxiosResponse = yield call(UpdateMasterApi, action);
    yield put(successUpdateMaster(response.data));
  } catch (error) {
    yield put(failureUpdateMaster(error));
  }
}

// delete master
const DeleteMasterApi = (action: PayloadAction<number>) => {
  return api.delete(`/users/${action.payload}`);
};
export function* DeleteMasterCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteMasterApi, action);
    yield put(successDeleteMaster(response.data));
  } catch (error) {
    yield put(failureDeleteMaster(error));
  }
}

// unlock OTP account
const UnlockMasterApi = (action: PayloadAction<{ phone: string }>) => {
  return api.post('/parkingOwner/unlock-otp-account', {
    phone: action.payload.phone,
  });
};

export function* UnlockMasterCall(action: PayloadAction<{ phone: string }>) {
  try {
    const response: AxiosResponse = yield call(UnlockMasterApi, action);
    yield put(successUnlockMaster(response.data));
  } catch (error) {
    yield put(failureUnlockMaster(error));
  }
}
